export const REJECTED_REASON = {
  QUALIFICATION_DOES_NOT_FULFIL_MINIMUM_REQUIREMENT: 1,
  YOUR_AREA_OF_EXPERTISE_DOES_NOT_LISTED_UNDER_THE_23_FIELDS_OF_TECHNOLOGY: 2,
  WORK_EXPERIENCE_IS_IRRELEVANT: 3,
  NOT_COVER_TECHNICAL_AND_TECHNOLOGY_SERVICES: 4,
  OTHERS_SECRETARIAT_CAN_WRITE_THE_REASON_MANUALLY: 5,
};

export const MapRejectionCategory = {
  1: 'Qualification does not fulfill minimum requirement',
  2: 'Your area of expertise does not listed under the 24 fields of technology',
  3: 'Work experience is irrelevant',
  4: 'Not Cover Technical and Technology services',
  5: 'Others - secretariat can write the reason manually'
};

export const SecretariatReason = [
  {
    label: "Does Not Meet Minimum Requirements",
    value: 1,
  },
  {
    label: "Institution or Program Not Recognized",
    value: 2,
  },
];

export function generateRejectionReasonOptions() {
  return Object.keys(REJECTED_REASON).map((key) => ({
    label: MapRejectionCategory[REJECTED_REASON[key]],
    value: REJECTED_REASON[key],
  }));
}

export const rejected_reasons_label_values = generateRejectionReasonOptions();
